import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { encryptStorage } from '../utils/storage';
import cleanImportLocationNotification from '../utils/cleanImportLocationNotification';
import localCache from '../utils/localCache';
import { STORAGE_KEYS, STORAGE_PREFIXES } from '../utils/storageKeys';
import { notifyBetaFeaturesChanged } from '../hooks/useBetaFeatures';

const DEVICE_KEYS = [
  STORAGE_KEYS.BETA_FEATURES,
  STORAGE_KEYS.THEME_MODE,
  STORAGE_KEYS.NIGHT_PALETTE,
  STORAGE_KEYS.HOME_LAYOUT,
];

export default function Logout() {
  const navigate = useNavigate();
  useEffect(() => {
    async function logoutUser() {
      // whatsNewSeenIds tracks the browser, not the user, and survives.
      ['authToken', 'userSession', 'lastLogin'].forEach((key) =>
        encryptStorage.removeItem(key),
      );

      // Device preferences stay; everything else would leak the previous user.
      Object.values(STORAGE_KEYS)
        .filter((key) => !DEVICE_KEYS.includes(key))
        .forEach((key) => localCache.remove(key));
      Object.values(STORAGE_PREFIXES).forEach((prefix) =>
        localCache.removeByPrefix(prefix),
      );
      cleanImportLocationNotification();
      notifyBetaFeaturesChanged();

      navigate('/sign_in');
    }

    logoutUser();
  });

  return null;
}
